export default "/images/56e40fed03daf5b8082dfa16a0c9e767.avif";